import { useRef, useState } from 'react';
import ExpertiseSection from './ExpertiseSection';
import FutureRow from './FutureRow';
import './HeroSection.css';


const futureItems = [
  {
    problem: "Learners don’t get practical experience or personal guidance.",
    solution: "ESkillite offers hands-on training, real projects, and 1:1 mentoring.",
  },
  {
    problem: "Students lack real industry exposure and mentor support.",
    solution: "We connect learners with industry mentors, internships, and live projects and placement Support.",
  },
  {
    problem: "Education institutions follow outdated curriculums and lack expert guidance.",
    solution: "We provide curriculum updates and technical consultancy to modernize learning.",
  },
  {
    problem: "Students have ideas but no support to build or present them.",
    solution: "we guide ideation, prototype development, competition preparation and organise hackathons.",
  },
];

const cardData = [
  {
    id: 1,
    title: "Personalized 1:1 Mentoring",
    subtitle: "From play time to problem solving Personalized Learning for Every Age",
    description:
      "At ESkillite, we believe learning should be personal and purposeful. Our 1:1 mentoring approach grows with your child from playful, real-world examples to advanced coding, aptitude training, and technical problem-solving for college students. Whether it's building curiosity in young minds or preparing graduates for high-demand careers, our mentors provide patient guidance, continuous feedback, and real-world exposure at every stage.",
    slogen: "Learn, Grow and Excel!",
    image:
      "/images/mentoring.png",
    reverse: false,
    bg: "bg1",
  },
  {
    id: 2,
    title: "Connect with Industry Mentors & Real-Time Projects",
    subtitle: "Learn from the Best. Work on What Matters.",
    description:
      "We bridge the gap between learning and the real world. ESkillite connects students with experienced industry mentors across domains like software development, design, data science, and more. Through live projects and virtual internships, learners gain practical skills, build portfolios, and develop the confidence to thrive in real work environments. It’s not just education  it’s experience.",
    slogen: "Connect , Build and Thrive!!",

    image:
      "/images/industry-connects.png",
    reverse: true,
    bg: "bg2",
  },
  {
    id: 3,
    title: "Curriculum Modernization & Career Guidance",
    subtitle: "Stay Ahead of the Curve – Technically and Professionally",
    description:
      "Eskillite empowers institutions with modern curriculum, engaging content, and hands-on learning modules. From coding to AI, we bring industry-aligned solutions that keep education future-ready. Partnering with schools and colleges, Eskillite bridges the gap between academics and industry. We deliver innovative curriculum, digital solutions, and skill-based training for tomorrow’s learners. Eskillite transforms education with industry-driven learning and technical consulting.",
    slogen: "Guidance.. Growth.. and Success.",
    image: "/images/career-guidence.png",
    reverse: false,
    bg: "bg3",
  },
  {
    id: 4,
    title: "Ideation, Prototyping & Competition Prep",
    subtitle: "From Ideas to Impact – We Nurture Innovators",
    description:
      "Got a big idea? We help you shape it. ESkillite guides students through the entire innovation journey — from brainstorming and building working prototypes to preparing for national and international competitions. With expert mentors, hands-on support, and structured prep programs, learners learn to think critically, present confidently, and stand out with impactful solutions.",
    image:
      "/images/competition.png",
    slogen: "Think, Build and Compete!!",
    reverse: true,
    bg: "bg4",
  },
];

const mentors = [
  {
    name: 'Dr. T.C. Subbu Lakshmi',
    role: 'Founder & CEO, Eskillite',
    image: '/images/ceo.jpg',
    link: 'https://l1nk.dev/FeZDI'
  },
  {
    name: 'Er. P.Harries Pandi',
    role: 'Co-Founder & CTO, Heyareweare Technologies Pvt Ltd',
    image: '/images/ctocofounder.jpg',
    link: 'https://www.linkedin.com/in/harriespandi/'
  },
  {
    name: 'Er. P.Abishua Blessmic',
    role: 'Software Developer',
    image: '/images/Seniordev.png',
    link: 'https://www.linkedin.com/in/abishuablessmic/'
  },
];

const MAX_LENGTH = 150;

const testimonials = [
  {
    name: "Abishua Blessmic E",
    rating: 5,
    text: "The mentorship I received completely shaped my way of thinking and learning. The clarity in resolving doubts, constant encouragement, and timely updates on new technologies inspired me to aim higher and stay ahead.",
    image: "/images/abishua.jpeg",
    desg: "Software Engineer"
  },
  {
    name: "Philip Chellakan",
    rating: 5,
    text: "I’ve been learning computer systems and C programming with Mrs. Subbu Lakshmi. She is patient, explains concepts clearly with examples, and breaks down tough topics step by step until I understand. This approach has strengthened my programming foundation, improved my consistency, and boosted my confidence. Beyond technical skills, she has also helped me develop a better problem-solving mindset and independent learning habits. I highly recommend Mrs. Subbu Lakshmi as a “as a tutor with - exceptional patience , clarity in demonstration and guidance”",
    image: "/images/philips.jpg",
    desg: "The University of California, US"
  },
  {
    name: "Gopika P",
    rating: 5,
    text: "One of my proudest achievements a project that went on to win awards was possible only because of the step-by-step guidance and vision provided by my mentor. That trust and support gave me the confidence to push my limits, explore new opportunities, and believe in myself.",
    image: "/images/gopika.png",
    desg: "UG Scholars"
  },
  {
    name: "Victoria Raina A",
    rating: 4,
    text: "Coming from a different background, I initially doubted myself. But the trust, equal treatment, and opportunities I received allowed me to explore, learn, and grow. That support built my confidence and shaped my path forward. I’ll always be grateful for the mentorship and inspiration that guided me",
    image: "/images/raina.jpg",
    desg: "UG Scholars"
  },
  {
    name: "Mohamed Riyaz S",
    rating: 5,
    text: "The patience, dedication, and genuine care throughout the journey made all the difference. It was more than teaching—it was true mentorship that built skills, confidence, and the mindset to grow.",
    image: "/images/riyaz.jpg",
    desg: "UG Scholars"
  },
  {
    name: "Aysha M",
    rating: 5,
    text: "I have never come across such passionate and dedicated mentor as Dr.Subbu Lakshmi T C. The sincerity, hard work, and constant encouragement truly inspire us to push beyond our limits. Being part of this learning journey has given me not just knowledge, but also confidence, motivation, and unforgettable experiences.",
    image: "/images/aysha.jpg",
    desg: "UG Scholars"
  }
];


function HeroSection() {
  const scrollRef = useRef(null);
  const [expanded, setExpanded] = useState({}); // store expanded states

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  const toggleReadMore = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index], // toggle the specific testimonial
    }));
  };

  return (
    <>
      {/*Hero Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <div className="logo-image">
            <img src="/images/logo.png" alt="Classroom" />
          </div>
          <h1>Empowering Minds,Inspiring Futures</h1>
          <p>
            Welcome to Eskillite Techserv! Get ready for learning and growing together.
            We're excited to have you here!
          </p>
          <div className="hero-buttons">
            <a href="#about" className="btn-primary">About</a>
            <a href="#contact" className="btn-outline">Contact</a>
            <ExpertiseSection />
          </div>
        </div>

      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="about-container">
          <div className="about-image">
            <img src="/images/about.jpg" alt="Classroom" />
          </div>

          <div className="about-content">
            <h1>
              Unlocking Knowledge <br /> with <span className="highlight">Eskillite</span>
            </h1>

            <div className="about-cards">
              <div className="about-card1">Vision
                <p className="about-p1">To empower individuals, communities, and organizations with the passion, skills, and ethics to create innovative and impactful solutions that drive growth, foster excellence, and contribute to global progress.</p>

              </div>
              <div className="about-card2">Mission
                <p className="about-p2">Our mission is to deliver accessible, hands-on, and industry-relevant education, mentoring, and project-based learning. We are committed to bridging the gap between academia and industry through ethical, skill-driven programs that encourage real-world problem solving, innovation, and inclusive growth.</p>
              </div>

            </div>

          </div>
        </div>

        <div className="stats">
          <div>
            <h2>150+</h2>
            <p>Hours Completed</p>
          </div>
          <div>
            <h2>50+</h2>
            <p>Students got Impacted</p>
          </div>
          <div>
            <h2>100%</h2>
            <p>Practical Learning</p>
          </div>
          <div>
            <h2>10+</h2>
            <p>Expert Mentors</p>
          </div>
          <div>
            <h2>90%</h2>
            <p>Positive feedback</p>
          </div>
        </div>
      </section>

      {/* Future Section */}
      <section className="future-section" id="service">
        <h2>
          Shaping Your Future With <span className="highlight">ESKILLITE</span>
        </h2>

        <div className="future-grid">
          {futureItems.map((item, index) => (
            <FutureRow key={index} item={item} />
          ))}
        </div>
      </section>

      <div className="mentoring-container">
        {cardData.map((card, index) => (
          <div
            key={index}
            className={`mentoring-card ${card.bg} ${card.reverse ? "reverse" : ""
              }`}
          >
            <div className="card-text">
              <h2>{card.title}</h2>
              <h3>{card.subtitle}</h3>
              <p>{card.description}</p>
              <h4>{card.slogen}</h4>
              <a href='https://forms.gle/bRQaQmKUTbC3V5zm6'><button>{card.button}JOIN NOW</button></a>
            </div>
            <div className="card-image">
              <img src={card.image} alt={card.title} />
            </div>
          </div>
        ))}
      </div>

      {/* Mentors Section */}
      <section className="mentors-section">
        <h2>Eskillite Mentors</h2>
        <div className="mentors-grid">
          {mentors.map((mentor, index) => (
            <div className="mentor-card" key={index}>
              <div className="mentor-image">
                <img src={mentor.image} alt={mentor.name} />
              </div>
              <h3>{mentor.name}</h3>
              <p className="mentor-role">{mentor.role}</p>

              {/* Link to external profile */}
              <a
                href={mentor.link}
                target="_blank"
                rel="noopener noreferrer"
                className="mentor-link"
              >
                Know Me
              </a>
            </div>
          ))}
        </div>

        <div className="mentor-join">
          <p>Would you like to join Eskillite as a Mentor?</p>
          <a href='https://forms.gle/qyfnRSDCcmAopsmT7'><button className="btn-join">Become a Mentor</button></a>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonial-section">
        <h2>
          What students say <br />
          about <span className="highlight">ESKILLITE TECHSERV</span> Mentors ?
        </h2>

        <div className="testimonial-carousel-wrapper">


          <div className="testimonial-carousel" ref={scrollRef}>
            {testimonials.map((t, index) => {
              const isExpanded = expanded[index];
              const shouldTruncate = t.text.length > MAX_LENGTH;

              return (
                <div className="testimonial-card" key={index}>
                  <div className="stars">
                    {"★".repeat(t.rating)}{t.rating < 5 ? "☆" : ""}
                  </div>
                  <p className="testimonial-text">
                    {isExpanded || !shouldTruncate
                      ? t.text
                      : t.text.slice(0, MAX_LENGTH) + "..."}
                    {shouldTruncate && (
                      <button
                        onClick={() => toggleReadMore(index)}
                        className="read-more-btn"
                      >
                        {isExpanded ? "Read less" : "Read more"}
                      </button>
                    )}
                  </p>
                  <div className="testimonial-footer">
                    <img src={t.image} alt={t.name} className="profile-pic" />
                    <div>
                      <strong>{t.name}</strong>
                      <p>{t.desg}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <button className="nav-button right" onClick={scrollRight}>❯</button>
        </div>
      </section>
      <section className="contact-section" id="contact">
        <div className="contact-info">
          <img src="/images/logo.png" alt="Eskillite Logo" className="eskillite-logo" />
          <p>Email support: <a href="mailto:info@eskillite.in">info@eskillite.in</a></p>
          <p>
            <strong>Address:</strong><br />
            110 E/11, Parijatham Street,<br />
            Vannarpettai,Tirunelveli,<br /> Tamilnadu - 627003
          </p>
          <p>
            <strong>Contact info:</strong>
            <a href="tel:9786770357">97867 70357</a>
          </p>

          <div className="social-icons">
            <a href="https://www.instagram.com/eskillite/"><img src="/images/insta.png" alt="Instagram" /></a>
            <a href="mailto:info@eskillite.in"><img src="/images/mail.png" alt="Gmail" /></a>
            <a href="https://www.linkedin.com/company/eskillitetechserv/?viewAsMember=true"><img src="/images/linkedin.png" alt="Linkedin" /></a>
          </div>
        </div>

        <div className='welcome-message'>
          <h2>Welcome to Eskillite! Get ready for learning and growing together.
            We're excited to have you here!</h2>
        </div>

        <div className="join-card">
          <img src="/images/bg.png" alt="Eskillite Logo" />
          <a href="https://whatsapp.com/channel/0029VbApmIm1NCrONILyOn2a" target="_blank" rel="noopener noreferrer">
            <button>Join Eskillite Community</button>
          </a>
        </div>
      </section>

    </>
  );
}

export default HeroSection;
